export const FETCH_TICKET = 'src/TICKET/FETCH_TICKET';
export const FETCH_TICKETS = 'src/TICKET/FETCH_TICKETS';
export const TICKET_CHANGE = 'src/TICKET/TICKET_CHANGE';
export const TICKET_EDIT_CHANGE = 'src/Ticket/TICKET_EDIT_CHANGE';
export const SET_TICKET_FORM_ERRORS = 'src/TICKET/SET_TICKET_FORM_ERRORS';
export const SET_TICKET_FORM_EDIT_ERRORS = 'src/Ticket/SET_TICKET_FORM_EDIT_ERRORS';
export const RESET_TICKET_FORM = 'src/TICKET/RESET_TICKET_FORM';
export const ADD_TICKET = 'src/TICKET/ADD_TICKET';
export const EDIT_TICKET = 'src/TICKET/EDIT_TICKET';
export const DELETE_TICKET = 'src/TICKET/DELETE_TICKET';
export const SET_TICKETS_LOADING = 'src/TICKET/SET_TICKETS_LOADING';
export const RESET_TICKET = 'src/Ticket/RESET_TICKET';
export const REMOVE_TICKET = 'src/Ticket/REMOVE_TICKET';
export const FETCH_USER_TICKET = 'src/Ticket/FETCH_USER_TICKET';
